import { createContext, useState } from "react";

const AppContext = createContext();

export default AppContext;

export const AppProvider = ({children}) => {
    const [blur, setBlur] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeForm = () => {
        setShowModal(false);
        setBlur(false);
    }

    const openForm = () => {
        setShowModal(true);
        setBlur(true);
    }

    const goHome = () => {
        window.location.href = '/'
    }

    const contextData = {
        blur,
        showModal,
        closeForm,
        openForm,
        goHome
    }

    return (
        <AppContext.Provider value={contextData}>
            {children}
        </AppContext.Provider>
    )
}